var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14.834C7.264 14.834 6.85067 14.664 6.51 14.324C6.17 13.9833 6 13.57 6 13.084V3.41797C6 2.93197 6.17 2.51864 6.51 2.17797C6.85067 1.83797 7.264 1.66797 7.75 1.66797H14.917C15.403 1.66797 15.816 1.83797 16.156 2.17797C16.4967 2.51864 16.667 2.93197 16.667 3.41797V13.084C16.667 13.57 16.4967 13.9833 16.156 14.324C15.816 14.664 15.403 14.834 14.917 14.834H7.75ZM7.75 13.084H14.917V3.41797H7.75V13.084ZM4.25 18.334C3.764 18.334 3.35067 18.164 3.01 17.824C2.67 17.4833 2.5 17.07 2.5 16.584V5.93897C2.5 5.7023 2.58667 5.4973 2.76 5.32397C2.934 5.14997 3.139 5.06297 3.375 5.06297C3.611 5.06297 3.816 5.14997 3.99 5.32397C4.16333 5.4973 4.25 5.7023 4.25 5.93897V16.584H12.396C12.632 16.584 12.8367 16.671 13.01 16.845C13.184 17.0183 13.271 17.223 13.271 17.459C13.271 17.695 13.184 17.9 13.01 18.074C12.8367 18.2473 12.632 18.334 12.396 18.334H4.25ZM7.75 3.41797V13.084V3.41797Z",
    fill: "#007E73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGreen);
export default __webpack_public_path__ + "static/media/copy-green.3284ee72e5339f6742e3dda7bcd827b4.svg";
export { ForwardRef as ReactComponent };